var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Share",
    transform: "translate(-18793 -2522)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37821",
    "data-name": "Ellipse 37821",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(18793 2522)",
    fill: "#e3f5ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633215",
    "data-name": "Group 633215",
    transform: "translate(18804.043 2533.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_858305",
    "data-name": "Path 858305",
    d: "M25.276,17.558,18.366,10v3.779C14.91,13.779,8,16.047,8,25.117c0-1.258,2.073-3.779,10.366-3.779v3.779Z",
    transform: "translate(-3.681 -4.601)",
    fill: "#356f92",
    stroke: "#356f92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858306",
    "data-name": "Path 858306",
    d: "M0,0H25.914V25.914H0Z",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareAlert);
export default __webpack_public_path__ + "static/media/ShareAlert.bf71a1fcca0d373cdf77ab35a5972a67.svg";
export { ForwardRef as ReactComponent };